import { IHooksUseRequestSuspendUserParams } from '@/interfaces';
import { useMutation } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { useInvalidateQueries } from '@/hooks';
import { broadcastService } from '@/services';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';

type TParams = {
  disableInvalidateQueries?: boolean;
};

type TDataVariables = IHooksUseRequestSuspendUserParams;
type TResponseData = void;

export const useRequestSuspendUser = (params?: TParams) => {

  const { invalidate } = useInvalidateQueries();
  const { isPending, error, mutateAsync } = useMutation({
    mutationKey: [routes.api.users.base, 'suspend'],
    mutationFn: (data: TDataVariables) =>
      apiClient
        .post<TResponseData>(routes.api.users.suspend, data)
        .then(handleApiResponse)
        .then(() => broadcastService.events.publish({ type: 'userSuspended', data })),
    onSuccess: () => (
      !params?.disableInvalidateQueries &&
      Promise
        .all([
          invalidate(routes.api.subAccounts),
          invalidate(routes.api.searchUser),
          invalidate(routes.api.users.base),
          invalidate(routes.api.reports.base)
        ])
    )
  });

  const triggerSuspendUser = (data: TDataVariables) =>
    mutateAsync(data);

  return ({
    isLoadingSuspendUser: isPending,
    triggerSuspendUser,
    error
  });

};
